import React, {Fragment} from 'react';
import MediaQuery from 'react-responsive';
import Icon from '../../UI/Icon/Icon';
import "./CandidateInterviewDecision.css"

const CandidateInterviewDecision = (props) => {
    return(
        <Fragment>

        {/* Desktop view sticky confirm button section starts */}
        <MediaQuery query="(max-device-width: 769px)">
            <div className="candidate-inteview-job-title-section-mobile">
                <p className="candidate-inteview-job-title">
                {props.client_interview_type} for 
                <span> {props.job_name}</span> with 
                <span> {props.company_name}</span>
                </p>
            </div>
        </MediaQuery>
        {/* Desktop view sticky confirm button section ends */} 

        <div className="candidate-inteview-decision-section-main">
            {/* Mobile view sticky confirm button section starts */}
            <MediaQuery query="(max-device-width: 769px)">
                <div className="cand-interview-decision">
                    <Icon 
                    className="cand-interview-decision-icon" 
                    icon={props.responseStatus==="Accepted"? "candidate-interview-green-success-icon":
                    props.allSlotsExpired? "candidate-interview-orange-expired-icon":"candidate-interview-blue-info-icon"}
                    />
                </div>
            </MediaQuery>
            {/* Mobile view sticky confirm button section ends */} 

            <div className="candidate-inteview-decision-content">
                {/* Desktop view sticky confirm button section starts */}
                <MediaQuery query="(min-device-width: 768px)">
                <div className="candidate-inteview-job-title-section">
                    <p className="candidate-inteview-job-title">
                    {props.client_interview_type} for 
                    <span> {props.job_name}</span> with 
                    <span> {props.company_name}</span>
                    </p>
                </div>
                </MediaQuery>
                {/* Desktop view sticky confirm button section ends */} 
                <div className="candidate-inteview-info-section">
                    {/* Desktop view sticky confirm button section starts */}
                    <MediaQuery query="(min-device-width: 768px)">
                        <div className="cand-interview-decision-desktop">
                            <Icon 
                                className="cand-interview-decision-icon" 
                                icon={props.responseStatus==="Accepted"? "candidate-interview-green-success-icon":
                                props.allSlotsExpired? "candidate-interview-orange-expired-icon":"candidate-interview-blue-info-icon"}
                            />
                        </div>
                    </MediaQuery>
                    {/* Desktop view sticky confirm button section ends */} 
                    <div className="candidate-inteview-decision-title">
                        <p>{props.responseStatus==="Accepted"? 
                            "Your interview has been successfully scheduled!" :
                            props.allSlotsExpired? 
                            (<div className="candidate-inteview-expired">
                                <p className="main-info">Sorry, your interview expired</p>
                                <p className="sub-info">Please get in touch with your 
                                recruiter to reschedule.</p>
                            </div>) : 
                            "Your recruiter has been notified and will follow up to discuss alternative options."}
                        </p>
                    </div>
                </div>
                {props.responseStatus==="Accepted"?
                    (<ul className="candidate-inteview-decision-message-info">
                        <li className="candidate-inteview-decision-message-list li-date">
                            <span className="cand-dec-title">Date:</span> 
                            <span className="cand-dec-info">{props.selectedDateTime.date?props.selectedDateTime.date:props.selectedSlotDetails.date?props.selectedSlotDetails.date:""}</span>
                        </li>
                        <li className="candidate-inteview-decision-message-list li-time">
                            <span className="cand-dec-title">Time:</span> 
                            <span className="cand-dec-info">{props.selectedDateTime.time?props.selectedDateTime.time:props.selectedSlotDetails.time?props.selectedSlotDetails.time:""}</span>
                        </li>
                        <li className="candidate-inteview-decision-message-list li-location">
                            <span className="cand-dec-title">Location:</span> 
                            <span className="cand-dec-info">{props.client_interview_location}</span>
                        </li>
                    </ul>) 
                    : ""}
            </div>
        </div>
        </Fragment>
    )
}

export default CandidateInterviewDecision;


// WEBPACK FOOTER //
// ./src/components/Candidate/CandidateInterviewDecision/CandidateInterviewDecision.js